module.exports = __webpack_public_path__ + "static/media/btc-icon.f7d64826.svg";